import { cn } from "@/shared/lib/utils";
import { X } from "lucide-react";
import { ReactNode } from "react";

interface DeletableBadgeProps {
  children: ReactNode;
  onDelete?: () => void;
  variant?: "default" | "secondary" | "destructive" | "outline" | "ok";
  className?: string;
}

export function DeletableBadge({
  children,
  onDelete,
  variant = "default",
  className,
}: DeletableBadgeProps) {
  const variants = {
    default: "bg-primary text-primary-foreground hover:bg-primary/80",
    secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
    ok: "bg-green-600 text-destructive-foreground hover:bg-green-600/80",
    destructive: "bg-red-600 text-destructive-foreground hover:bg-red-600/80",
    outline:
      "text-foreground border border-input bg-background hover:bg-accent hover:text-accent-foreground",
  };

  return (
    <div
      className={cn(
        "group focus:ring-ring inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none",
        variants[variant],
        className,
      )}
    >
      <span>{children}</span>
      {onDelete && (
        <button
          type="button"
          onClick={onDelete}
          className="-mr-1 ml-1 flex w-0 items-center justify-center overflow-hidden rounded-full transition-all duration-200 group-hover:w-4 hover:bg-black/10"
          aria-label="Remove badge"
        >
          <X className="h-3 w-3 flex-shrink-0" />
        </button>
      )}
    </div>
  );
}
